export default [
	{
		settings: true,
		text: "Customer",
		value: "customer",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Email",
		value: "email",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Report",
		value: "report",
		model: { value: 'list' },
		dense: true,
		align: 'center'
	}
];
